module.exports = __webpack_public_path__ + "img/antes_despues_327.15f29c54.png";